module.exports = __webpack_public_path__ + "fonts/Inter-900-greek63.3a3cf1a.woff2";